import { ChatState } from "@/domains/chat/slice";

export const tooltips: ChatState["tooltipCommands"] = [
  {
    value: "me",
    args: ["действие"],
    description: "Описание действия персонажа",
  },
  {
    value: "do",
    args: ["действие"],
    description: "Аналог /me",
  },
  {
    value: "b",
    args: ["сообщение"],
    description: "Out of character (вне игры) чат",
  },
  {
    value: "s",
    args: ["сообщение"],
    description: "Говорит вслух",
  },
  {
    value: "y",
    args: ["сообщение"],
    description: "Кричит (больший радиус действия)",
  },
  {
    value: "w",
    args: ["имя игрока", "сообщение"],
    description: "Шепчет персонажу",
  },
  {
    value: "r",
    args: ["сообщение"],
    description: "Радиопередача",
  },
  {
    value: "try",
    args: ["действие"],
    description: "Попытка выполнить действие (с вероятностью успеха/неудачи)",
  },
  {
    value: "search",
    args: ["имя игрока/объекта"],
    description: "Обыск игрока или объекта",
  },
  {
    value: "inv",
    description: "Просмотр инвентаря",
  },
  {
    value: "drop",
    args: ["предмет"],
    description: "Выбросить предмет",
  },
  {
    value: "use",
    args: ["предмет"],
    description: "Использовать предмет",
  },
  {
    value: "give",
    args: ["имя игрока", "предмет", "количество"],
    description: "Дать предмет другому игроку",
  },
  {
    value: "take",
    args: ["имя игрока", "предмет", "количество"],
    description: "Забрать предмет у игрока",
  },
  {
    value: "aim",
    args: ["оружие"],
    description: "Навести оружие",
  },
  {
    value: "cuff",
    args: ["имя игрока"],
    description: "Задержать игрока наручниками",
  },
  {
    value: "uncuff",
    args: ["имя игрока"],
    description: "Снять наручники",
  },
  {
    value: "arrest",
    args: ["имя игрока"],
    description: "Арестовать игрока",
  },
  {
    value: "release",
    args: ["имя игрока"],
    description: "Освободить арестованного",
  },
  {
    value: "car",
    description: "Вызвать машину",
  },
  {
    value: "bike",
    description: "Вызвать мотоцикл",
  },
  {
    value: "vehicle",
    description: "Более общий вариант для вызова транспорта",
  },
  {
    value: "lock",
    description: "Запереть машину/дверь",
  },
  {
    value: "unlock",
    description: "Отпереть машину/дверь",
  },
  {
    value: "engine",
    description: "Включить/выключить двигатель",
  },
  {
    value: "fuel",
    description: "Заправить машину",
  },
  {
    value: "trunk",
    description: "Открыть багажник",
  },
  {
    value: "job",
    description: "Начать работу",
  },
  {
    value: "quitjob",
    description: "Уйти с работы",
  },
  {
    value: "salary",
    description: "Получить зарплату",
  },
  {
    value: "business",
    description: "Действия, связанные с владением бизнесом",
  },
  {
    value: "fa",
    description: "Команды, относящиеся к семье",
  },
  {
    value: "faction",
    description: "Команды, относящиеся к фракции игрока",
  },
  {
    value: "f",
    description: "Команды, относящиеся к фракции игрока",
  },
  {
    value: "n",
    description: "Команды, относящиеся к новостям",
  },
  {
    value: "rank",
    description: "Показать текущий ранг во фракции",
  },
  {
    value: "promote",
    description: "(Часто только для лидеров)",
  },
  {
    value: "demote",
    description: "(Часто только для лидеров)",
  },
  {
    value: "invite",
    description: "(К фракции)",
  },
  // {
  //   value: "ban",
  //   args: ["имя игрока", 'причина'],
  //   description: "Забанить игрока",
  // },
  // {
  //   value: "kick",
  //   args: ["имя игрока", 'причина'],
  //   description: "Кикнуть игрока",
  // },
  // {
  //   value: "warn",
  //   args: ["имя игрока", 'причина'],
  //   description: "Предупредить игрока",
  // },
  // {
  //   value: "tp",
  //   args: ["имя игрока/координаты"],
  //   description: "Телепортироваться к игроку или в координаты",
  // },
  // {
  //   value: "givemoney",
  //   args: ["имя игрока"],
  //   description: "сумма",
  // },
];
